
import card from '~/mixins/card'
export default {
    mixins: [card],
    props: {
        magicUrl: { type: String, default: '/' },
    },
}
